module.exports = __webpack_public_path__ + "img/norte-cipher-preview.955c3b31.png";